/*
 * Marketing pages that no longer exist (booking-era industry landing pages, comparisons with booking tools, the booking feature tour,
 * retired healthcare pages). Old links and search results go home. The wildcard is regexparam's "*?": it also matches the bare path.
 */
export const RETIRED_MARKETING_PATHS: readonly string[] = [
  '/for-salons',
  '/for-barbers',
  '/for-beauty',
  '/for-spa',
  '/for-trainers',
  '/for-coaches',
  '/for-golf-teachers',
  '/for-doctors',
  '/for-clinics',
  '/for-therapists',
  // the booking-era comparisons (with scheduling tools); the new /compare/scopie-vs-<competitor> pages are not these
  '/compare',
  '/compare/calendly',
  '/compare/acuity',
  '/compare/simplybook',
  '/features',
];
